import { savedOrderDetailsCartLineStyles as cartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { savedOrderDetailsProductListStyles as styles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        padding: 0;
        margin-top: 40px;
        border: none;
    `,
};

styles.cartLineCardContainer = {
    ...styles.cartLineCardContainer,
    cardDivider: {
        ...styles.cartLineCardContainer?.cardDivider,
        css: css`
            ${styles.cartLineCardContainer?.cardDivider?.css}
            border-bottom: none;
        `,
    },
};

cartLineStyles.container = {
    ...cartLineStyles.container,
    css: css`
        ${cartLineStyles.container?.css}
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;
        & + div {
            margin-top: 24px;
        }
    `,
};

cartLineStyles.productImageGridItem = {
    ...cartLineStyles.productImageGridItem,
    width: [3, 3, 2, 1, 1],
    css: css`
        ${cartLineStyles.savedOrderLineCardAddToListGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            padding-inline: 20px;
        }
    `,
};

cartLineStyles.savedOrderLineInfoGridItem = {
    ...cartLineStyles.savedOrderLineInfoGridItem,
    width: [12, 12, 10, 11, 11],
    css: css`
        ${cartLineStyles.savedOrderLineInfoGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            padding-inline: 20px;
        }
    `,
};

cartLineStyles.priceGridItem = {
    ...cartLineStyles.priceGridItem,
    width: [12, 12, 12, 3, 3],
};

cartLineStyles.quantityGridItem = {
    ...cartLineStyles,
    width: [2, 2, 2, 2, 2],
};

cartLineStyles.subtotalWithoutVatText = {
    ...cartLineStyles.subtotalWithoutVatText,
    text: {
        ...cartLineStyles.subtotalWithoutVatText?.heading,
        weight: 400,
    },
};

cartLineStyles.extendedUnitNetPrice = {
    ...cartLineStyles.extendedUnitNetPrice,
    text: {
        ...cartLineStyles.extendedUnitNetPrice?.heading,
        weight: 400,
    },
};

cartLineStyles.savedOrderLineCardAddToListGridItem = {
    ...cartLineStyles.savedOrderLineCardAddToListGridItem,
    css: css`
        ${cartLineStyles.savedOrderLineCardAddToListGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            padding-right: 20px;
            justify-content: flex-end;
        }
    `,
};

cartLineStyles.savedOrderLineCardAddToListButton = {
    ...cartLineStyles.savedOrderLineCardAddToListButton,
    css: css`
        ${cartLineStyles.savedOrderLineCardAddToListButton?.css}
        ${mediaQueriesBP.maxMD} {
            min-height: 50px;
            padding: 0 16px;
        }
    `,
};
